<template>
  <component
    :is="componentType"
    class="ctx-button"
    v-bind="$attrs"
    :disabled="disabled || loading"
    :type="componentType === 'button' ? nativeType : null"
    :to="route"
    :href="href"
    :class="{
        ['size--' + size]: size,
        ['styling--' + styling] : styling,
        'is-disabled': disabled,
        'is-loading': loading,
        'is-icon-only': iconOnly
      }"
  >
    <i class="el-icon-loading" v-if="loading"></i>
    <i :class="icon" v-if="icon && !loading"></i>
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: 'CtxButton',
  props: {
    styling: {
      type: String,
      default: 'default',
      validator: value => ['default', 'outlined', 'blue', 'transparent'].includes(value)
    },
    size: {
      type: String,
      validator: value => ['small'].includes(value)
    },
    icon: String,
    nativeType: {
      type: String,
      default: 'button',
      validator: value => ['button', 'submit'].includes(value)
    },
    loading: Boolean,
    disabled: Boolean,
    iconOnly: Boolean,
    href: String,
    route: [String, Object]
  },
  data () {
    return {
      componentType: this.route ? 'router-link' : this.href ? 'a' : 'button'
    }
  }
}
</script>

<style scoped>
.ctx-button {
  height: 46px;
  border: 0;
  line-height: 30px;
  font-size: 15px;
  padding: 8px 23px;
  transition: opacity .25s, background-color .25s, color .25s, filter .25s;
  text-decoration: none;
  display: inline-flex;
  cursor: pointer;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: #fff;

  [class*=icon-] {
    font-size: 20px;
    margin-right: 5px;
  }

  &:focus {
    outline: 1px dotted #353535;
  }

  &.is-icon-only {
    background: none;
    color: #353535;

    [class*=icon-] {
      margin-right: 0;
    }
  }

  & + & {
    margin-left: 10px;
  }

  &.is-disabled {
    cursor: not-allowed;
    background-color: #c2c2c2;
  }

  &.is-disabled,
  &.is-loading {
    opacity: .8;
  }

  &.styling--default {
    background: var(--purple);
    color: #fff;

    &:hover {
      background: #701968;
    }
  }

  &.styling--outlined {
    border: 2px solid #923884;
    color: #923884;
    background: #fff;

    &:hover {
      background-color: #701968;
      color: #fff;
    }
  }

  &.styling--blue {
    background: var(--blue);

    &:hover {
      background-color: #003e76;
    }
  }

  &.styling--transparent {
    background: transparent;
    color: var(--purple);

    &.is-disabled {
      @apply text-gray-400;
    }
  }

  &.size--small {
    height: 32px;
    line-height: 22px;
    font-size: 12px;
    padding: 5px 11px;
  }
}

.citizen-m .ctx-button {
  &.styling--default {
    background: #317934;

    &:hover {
      background: #317934;
      filter: brightness(.9);
    }
  }

  &.styling--outlined {
    border: 2px solid #317934;
    color: #317934;

    &:hover {
      background-color: #317934;
      color: #fff;
    }
  }

  &.styling--transparent {
    color: #317934;
  }
}
</style>
